import { setGlobalVariable } from "../shared";
import "./LionAssessment.css";
import { useGlobalState } from '../state/index';

import React, {
  useState,
  useEffect,
  StrictMode,
  useCallback,
  useMemo,
  useRef,
} from "react";
import "../App.css"; // Adjust the CSS import path
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import CustomButtonComponent from "./customButtonComponent";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

let globalIntValue = null;

function LionAssessment({
  studntIdData,
  StudentName,
  districtName,
  districtID,
  baseUrl,
  lionResult1,
  activeTab,
  lionAssessmentList,
  lionActiveTab,
  loadingResults,
}) {
  const [intValue, setIntValue] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startCode, setStartCode] = useState();
  const [language, setLanguage] = useState();
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const [seAccessReadOnly] = useGlobalState("SEAccessReadOnly");
  const downArrow = require("../icons/downarrow.png");

  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      axios
        .get(
          baseUrl +
          `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`,
          { headers }
        )
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log("Fetched intValue:", fetchedValue);
        })
        .catch((error) => {
          console.error("Error fetching intValue:", error);
        });
    }
  }, []);

  const jsonObj1 = JSON.parse(lionResult1);
  const inSeasonValue = jsonObj1?.inSeasonValue || "BOY";
  const [activeTabs, setActiveTab] = useState(null);

  useEffect(() => {
    setActiveTab(inSeasonValue);
  }, [inSeasonValue]);

  const data = Array.isArray(jsonObj1?.lionRes1) ? jsonObj1.lionRes1 : [];

  let uniqueSeason = [
    ...new Set(
      data
        .filter((item) => item.Season != "") // Filter out items with null or undefined id
        .map((item) => item.Season.toString()) // Convert id to string
    ),
  ];

  const customOrder = ["BOY", "MOY", "EOY", "SUMMER", "PM"];

  uniqueSeason.sort((a, b) => {
    return customOrder.indexOf(a) - customOrder.indexOf(b);
  });

  const groupedData = data.reduce((acc, curr) => {
    if (!acc[curr.Season]) {
      acc[curr.Season] = [];
    }
    acc[curr.Season].push(curr);
    return acc;
  }, {});

  // Handle tab click to change active tab
  const handleTabClick = (season) => {
    setActiveTab(season);
  };

  let loadData = [];
  if (Object.keys(groupedData).length > 0 && activeTabs) {
    loadData = groupedData[activeTabs] || [];
  }

  //const [activeTabs, setActiveTab] = useState('BOY');
  //activeTabs  = jsonObj1.inSeasonValue;

  // // Handle tab click to change active tab
  // const handleTabClick = (season) => {
  //   setActiveTab(season);
  //   lionAssessmentList[season].map((item, index) => {
  //     loadData.push(item);
  //   });
  // };

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
  }, []);

  // let loadData = [];
  // if (Object.keys(lionAssessmentList).length != 0) {
  //   lionAssessmentList[activeTabs].map((item, index) => {
  //     loadData.push(item);
  //   });
  // }

  const lionLogin = (props) => {
    const isReadOnly = seAccessReadOnly || sessionStorage.getItem("SEAccessReadOnly") === "true";
    const isClickable = props.data.Complete != 2 && props.data.InSeason == "Yes" && !isReadOnly;
    
    return (
      <div translate="no">
        {props.data.Complete != 2 && props.data.InSeason == "Yes" ?
          <span 
            className="lionLogin" 
            onClick={() => !isReadOnly && openModal(props.data)}
            style={{
              opacity: isReadOnly ? 0.5 : 1,
              cursor: isReadOnly ? "not-allowed" : "pointer",
              textDecoration: isReadOnly ? "none" : "underline"
            }}
            title={isReadOnly ? "Access is read-only" : ""}
          >
            {props.data.StartCode}
          </span>
          :
          props.data.Complete == 2 ? props.data.StartCode : props.data.StartCode
        }
      </div>
    );
  };

  const [columnDefs] = useState([
    {
      field: "actions",
      headerName: "Status",
      cellRenderer: CustomButtonComponent,
      cellStyle: { textAlign: "center" },
      flex: 2,
      minWidth: 150,
    },
    {
      headerName: "Subject",
      field: "BMPM",
      filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" },
      flex: 2,
      minWidth: 150,
      sort: "asc",
    },
    {
      headerName: "Language",
      field: "Language",
      filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center", alignItems: "center" },
      flex: 2,
      minWidth: 150,
    },
    {
      headerName: "Start Code",
      field: "actions",
      cellRenderer: lionLogin,
      filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" },
      flex: 2,
      minWidth: 150,
    },
  ]);

  const gridOptions = {
    icons: {
      sortAscending: '<span class="ag-icon ag-icon-desc">▲</span>',
      sortDescending: '<span class="ag-icon ag-icon-asc">▼</span>',
    },
  };

  // Function to open the modal
  const openModal = (item) => {
    setStartCode(item.StartCode);
    setIsModalOpen(true);
    setLanguage(item.Language);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Function to close the modal
  const lionLoginFromExplorer = () => {
    setIsModalOpen(false);
    let a = document.createElement("a");
    a.target = "_blank";
    a.href =
      "https://lion.tangosoftware.com/LION/AutoLoginFromExplorer?districtID=" +
      districtID +
      "&studentId=" +
      studntIdData +
      "&startCode=" +
      startCode;
    a.click();
  };

  // Styles for modal and overlay (optional)
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000, // Ensure it's on top of other content
    },
    modalContent: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
    },
  };

  const returnLIONData = () => {
    if (loadingResults) {
      return (
        <div className="spinner-container">
          <div className="spinner"></div>
          <p>Loading results...</p>
        </div>
      );
    }
    return (
      <div>
        {Object.keys(lionAssessmentList).length > 0 ? (
          <div>
            <div className="tabs" translate="no">
              {uniqueSeason.map((season, index) => (
                <button
                  key={season}
                  className={`tab ${activeTabs === season ? "active" : ""}`}
                  onClick={() => handleTabClick(season)}
                >
                  {season}
                </button>
              ))}
            </div>

            <div className="tab-content">
              <div className="tab-item">
                <div class="table-wrapper">
                  <div
                    className="ag-theme-alpine"
                    style={{ height: "400px", width: "100%" }}
                  >
                    <AgGridReact
                      gridOptions={gridOptions}
                      rowData={loadData}
                      columnDefs={columnDefs}
                      domLayout="autoHeight"
                      suppressScrollOnNewData={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: "10%" }}>
            <h3>No data available</h3>
          </div>
        )}
        {isModalOpen && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <div translate="no">
                {language === "English" ? (
                  <h4>LION Auto-login</h4>
                ) : (
                  <h4>Inicio de sesión automático</h4>
                )}
              </div>

              <div>
                <p translate="no">
                  {language === "English" ? (
                    <>
                      Do you want to login using <strong>{startCode}</strong> as
                      the start code?
                    </>
                  ) : (
                    <>
                      ¿Quieres iniciar sesión utilizando{" "}
                      <strong>{startCode}</strong> como código de inicio?
                    </>
                  )}
                </p>
              </div>

              <div translate="no">
                <button className="button-3" onClick={closeModal}>
                  {language === "English" ? "No" : "No"}
                </button>
                <button className="button-3" onClick={lionLoginFromExplorer}>
                  {language === "English" ? "Yes" : "Sí"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div>
        {/* <h2>Assessments</h2> */}
        {returnLIONData()}
      </div>

      {showScrollIndicator && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            background: "#d0cfcf99",
            color: "white",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            zIndex: 9999,
            cursor: "pointer",
            animation: "bounce 1.5s infinite",
          }}
          onClick={() =>
            window.scrollBy({ top: 200, behavior: "smooth" })
          }
        >
          <img
            src={downArrow}
            alt="Scroll down"
            style={{ width: "22px", height: "22px" }}
          />
        </div>
      )}
    </>

  );
}

export default LionAssessment;
